// extracted by mini-css-extract-plugin
export default {"steps":"fD_QGh","inactiveStep":"eRficy","activeStep":"UjETUR","mobile":"RMVN5Q"};